<template>
    <div
        class="c-sticky-media"
        :class="{ 'is-visible': isActive }"
        :style="{
            zIndex: `${stackingIndex}`,
        }"
    >
        <img
            v-if="imageSrc"
            class="c-sticky-media__image"
            :src="imageSrc"
            :alt="imageAlt"
            :style="dynamicImageStyles"
        />
    </div>
</template>

<script setup lang="ts">
import type { ObjectPositionOption } from '~/@coloplast/design-system/dist/types/types/object-position';
import { computed } from "vue";

type Props = {
    stackingIndex: number;
    isActive: boolean;
    imageAlt?: string;
    imageSrc: string;
    mediaFocalPoint?: ObjectPositionOption;
};

const props = withDefaults(defineProps<Props>(), { mediaFocalPoint: "center" });

const dynamicImageStyles = computed(() => {
    const styles = [];
    if (props.mediaFocalPoint !== "center") {
        styles.push(`--object-position: ${props.mediaFocalPoint};`);
    }
    return styles;
});
</script>
